import { render } from "./CampusAppPage.vue?vue&type=template&id=6a414227"
import script from "./CampusAppPage.vue?vue&type=script&lang=js"
export * from "./CampusAppPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/CampusAppPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a414227"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a414227', __exports__)) {
    api.reload('6a414227', __exports__)
  }
  
  module.hot.accept("./CampusAppPage.vue?vue&type=template&id=6a414227", () => {
    api.rerender('6a414227', render)
  })

}


export default __exports__